const mimetypeFromExtension = (extn: string): string[] => {
	switch (extn) {
		case "*.jpg": return ['image/jpeg']
		case '*.gif': return ['image/gif']
		case '*.png': return ['image/png']
		case '*.csv': return ['text/csv']
		case '*.flv': return ['video/x-flv']
		case '*.mov': return ['video/quicktime']
		case '*.wmv': return ['video/x-ms-wmv']
		case '*.mp4': return ['video/mp4']
		case '*.zip': return ['application/zip', 'application/x-zip', 'application/x-zip-compressed']
	}

	return []
}

// our extensions are globs: *.zip. browsers only care about the ending: .zip. This assumes and requires the glob to start with *
const browserExtn = (extn: string): string =>
	extn.substr(1)

export const makeAcceptFromExtensions  = (extns: string)  =>
	extns.split(';').map(extn => mimetypeFromExtension(extn.trim()).concat(browserExtn(extn))).reduce(concat)

export const matchesGlob = (filename: string, extns: string): boolean =>
	!extns || extns.length == 0 || extns == '*.*' || extns.split(';').map(extn => extn.trim().slice(-3)).indexOf(filename.slice(-3)) >= 0

const concat = <T> (a: T[], b: T[]): T[] => a.concat(b)


// WEBPACK FOOTER //
// ./src/lib/extensions.ts